module.exports = __webpack_public_path__ + "static/fonts/Oswald-Stencil.eccf06e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/formats/font/Oswald-Stencil.ttf
// module id = V+ly
// module chunks = 1